import { useLocation } from "react-router-dom";

import { VerifyTotpForm } from "@/features/sign-in/components/verify-totp.form";

export function VerifySMS() {
  const location = useLocation();
  const phoneNumber: string | undefined = location.state?.phoneNumber;

  return (
    <div>
      <div className="px-4 sm:px-6">
        <p className="text-lg font-medium text-foreground">
          Two-step verification
        </p>
        <p className="text-base font-normal text-muted">
          To continue, please enter the verification code <br /> sent to{" "}
          <span className="font-medium">
            {phoneNumber ? phoneNumber : "your phone number"}.
          </span>
        </p>
        <div className="my-8 sm:my-11">
          <VerifyTotpForm />
        </div>
      </div>
    </div>
  );
}
